const disableCopyPaste = (e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  e.preventDefault();
  return false;
};

export default disableCopyPaste;
